export default __webpack_public_path__ + "static/media/hotline_icon.d9dbcb0f.svg";